// Иконки кабинета: линейные 24×24, обводка currentColor (класс .ico в components.css).
// Набор перенесён из макета docs/design/redesign-2026-10/mockups/final/icons.js.
// Значение — либо путь `d` одного <path>, либо готовая разметка из нескольких фигур.

const ICONS = {
  flag: "M5 21V4M5 4h12l-2 4 2 4H5",
  home: "M3 11l9-8 9 8M5 10v10h5v-6h4v6h5V10",
  chat: "M4 5h16v11H9l-5 4z",
  users: '<circle cx="9" cy="8" r="3"/><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6M16 5.5a3 3 0 010 5.5M17 14.3c2.3.6 4 2.6 4 5.7"/>',
  book: "M5 4h11a3 3 0 013 3v13H8a3 3 0 01-3-3z M5 17a3 3 0 013-3h11",
  script: "M6 3h9l4 4v14H6z M14 3v5h5 M9 13h7M9 17h7",
  plug: "M9 3v5M15 3v5M6 8h12v3a6 6 0 01-12 0z M12 17v4",
  globe: '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18"/>',
  bell: "M6 16v-5a6 6 0 0112 0v5l2 2H4z M10 21h4",
  wallet: "M3 7h16a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2z M3 7l2-3h12 M16 14h2",
  sliders: "M4 7h9M17 7h3M4 17h3M11 17h9 M15 5v4M9 15v4",
  sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5L19 19M5 19l1.5-1.5M17.5 6.5L19 5"/>',
  moon: "M20 14.5A8 8 0 019.5 4 8 8 0 1020 14.5z",
  check: "M5 12.5l4.5 4.5L19 7.5",
  arrow: "M5 12h14M13 6l6 6-6 6",
  back: "M19 12H5M11 6l-6 6 6 6",
  copy: '<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V6a2 2 0 012-2h9"/>',
  send: "M21 3L3 10.5l6.5 2.5L12 20z M9.5 13L21 3",
  bulb: "M9 18h6M10 21h4M12 3a6 6 0 00-4 10.5c.7.7 1 1.5 1 2.5h6c0-1 .3-1.8 1-2.5A6 6 0 0012 3z",
  chev: "M6 9l6 6 6-6",
  chevr: "M9 6l6 6-6 6",
  more: '<circle cx="5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/>',
  alert: "M12 3l10 18H2z M12 10v5M12 18v.5",
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8v.5"/>',
  x: "M6 6l12 12M18 6L6 18",
  plus: "M12 5v14M5 12h14",
  refresh: "M20 12a8 8 0 11-2.5-5.8M20 4v5h-5",
  trash: "M4 7h16M10 7V4h4v3M6 7l1 13h10l1-13M10 11v6M14 11v6",
  lock: '<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/>',
  sort: "M8 4v16M8 4L5 7M8 4l3 3M16 20V4M16 20l-3-3M16 20l3-3",
  logo: "M5 6h14v9H10l-5 4z",
} as const;

export type IconName = keyof typeof ICONS;

export function Icon({ name, small = false, className = "" }: { name: IconName; small?: boolean; className?: string }) {
  const shape: string = ICONS[name];
  const cls = ["ico", small ? "ico--sm" : "", className].filter(Boolean).join(" ");
  return shape.startsWith("<") ? (
    <svg className={cls} viewBox="0 0 24 24" aria-hidden="true" focusable="false" dangerouslySetInnerHTML={{ __html: shape }} />
  ) : (
    <svg className={cls} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d={shape} />
    </svg>
  );
}
